import { useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Crown } from "@phosphor-icons/react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, King.");
      const next = loc.state?.from || "/admin";
      nav(next, { replace: true });
    } catch (e) {
      const detail = e?.response?.data?.detail || "Login failed";
      setErr(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24" data-testid="login-page">
      <div className="section-eyebrow"><Crown size={14} weight="fill" /> Admin</div>
      <h1 className="font-display text-5xl uppercase mt-3">Sign In</h1>
      <p className="text-dim mt-2">Only the King passes this gate.</p>

      <form onSubmit={submit} className="scu-card p-6 mt-8 space-y-4" data-testid="login-form">
        <label className="block">
          <span className="text-xs uppercase tracking-widest text-dim">Email</span>
          <input
            type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            className="mt-1 w-full bg-black border border-white/15 px-4 py-3 focus:border-[#FF3B30] outline-none"
            data-testid="login-email"
          />
        </label>
        <label className="block">
          <span className="text-xs uppercase tracking-widest text-dim">Password</span>
          <input
            type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            className="mt-1 w-full bg-black border border-white/15 px-4 py-3 focus:border-[#FF3B30] outline-none"
            data-testid="login-password"
          />
        </label>
        {err && <div className="text-[#FF3B30] text-sm" data-testid="login-error">{err}</div>}
        <button type="submit" disabled={loading} className="btn-red w-full" data-testid="login-submit">
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>
    </div>
  );
}
